import { Dispatch } from 'redux'
import { TEUDOT_PROBLEMS } from '../../components/modules/API/TeudotProblems/teudotProblems'
import { IProblemListItem } from '../../components/modules/API/TeudotProblems/models/problems'
import { LOAD_PROBLEM_TYPES, LOAD, LOAD_END } from './actionsTypes'

export const loadProblemTypes = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: LOAD })
    const problemTypes: IProblemListItem[] = await TEUDOT_PROBLEMS.getProblemList()
    dispatch({
      type: LOAD_PROBLEM_TYPES,
      payload: problemTypes
    })
  } catch (error) {
    console.error('Error loading problem types:', error)
  } finally {
    dispatch({ type: LOAD_END })
  }
} 